/*** IMPORTS FROM imports-loader ***/
(function() {


/**
 * Created by tford on 5/25/16.
 */

/*
 * Friend Request Modal
 * Used just after a user has unblocked someone.
 * Allows user to send friend request or wait.
 */

define('fitbit-jquery-friendRequestModal',['require'],function(require) {

    // Prevent duplicate initialization
    if ($.isFunction($.fn.friendRequestModal)) {
        return;
    }

    /*
     * jQuery plugin
     */
    $.fn.friendRequestModal = function(options) {
        var $self = $(this),
            $modalContent = $self.find('#friendRequestContent'),
            $successMessage = $self.find('#friendRequestSuccess'),
            $errorMessage = $self.find('#friendRequestError'),
            bindEvents = function() {
                $self.find(".friend-request-controls .send").click(function(e) {
                    e.stopPropagation(); // Don't propagate to e.g. notification dropdown.
                    if (options.callback && typeof options.callback == 'function') {
                        if (options.closeBeforeCallback) {
                            $self.data("overlay").close();
                        }
                        options.callback();
                    }
                });
                $self.find(".friend-request-controls .cancel").click(function(e) {
                    e.stopPropagation(); // Don't propagate to e.g. notification dropdown.
                    $self.data("overlay").close();
                });
                $('#blocking-mask').click(function(e) {
                    e.stopPropagation();
                    $self.data("overlay").close();
                });
            },
            unbindEvents = function() { 
                $self.find(".friend-request-controls .send").unbind('click');
                $('#blocking-mask').unbind('click');
            },
            handleClose = function() {
                unbindEvents();
                $self.data("overlay", null);
            },
            addData = function() {
                if (options.userName) {
                    $self.find('.name').text(options.userName);
                }
            };

        addData();

        $self.overlay({
            mask: {
                maskId: 'blocking-mask',
                color: "#000",
                zIndex: 199998,
                closeOnClick: false
            },
            onClose: function() {
                setTimeout(handleClose, 0); // Required to let overlay's mask fully close.
            }
        });
        $self.data("overlay").load();
        $successMessage.hide();
        $errorMessage.hide();
        $modalContent.show();
        bindEvents();
    };
}); // End define block.
;}.call(window));


/** WEBPACK FOOTER **
 ** /tmpfs/src/git/fitbit-site-weightsite/catpack/~/imports-loader?this=>window!/tmpfs/src/git/fitbit-site-weightsite/catpack/web_loaders/requirejs-loader?{"config":{"entryPaths":["./js/fitbitui/friendRequestModal.js"],"name":"fitbit-jquery-friendRequestModal","exclude":["jquery"],"paths":{"shared/build/css/components/shared/styles","com/conf/webapp/common/resources/i18n/com/fitbit","core/core/i18n/src/main/resources/resources/i18n/com/fitbit"},"inlineText":true,"pragmasOnSave":{"excludeHbs":true,"excludeI18n":true}}}!./js/fitbitui/friendRequestModal.js
 **/